/**
 * @namespace Dialog
 * @aka SWRNEU.Dialog
 */
(function ($) {
  const url = new URL(window.location);
  const searchParams = url.searchParams;

  //Die Uhrzeit für Fractal kann über die URL-Parameter
  //fractalHours -> Stunden
  //fractalMinutes -> Minuten
  //gesetzt werden. Standardmäßig ist es in Fractal immer 5:25
  //Die Uhrzeit wird in 5-Minuten-Schritten in der update-Funktion
  //hochgezählt und springt bei Mitternacht wieder zurück auf 5:25
  let fractalHours = parseInt(searchParams.get('fractalHours')) || 5;
  let fractalMinutes = parseInt(searchParams.get('fractalMinutes')) || 25;
  let currentFractalTime;

  function updateFractalTime () {
    console.log('2090-03-26T' + (fractalHours < 10 ? '0' + fractalHours : fractalHours) + ':' + (fractalMinutes < 10 ? '0' + fractalMinutes : fractalMinutes));
    currentFractalTime = dayjs('2090-03-26T' + (fractalHours < 10 ? '0' + fractalHours : fractalHours) + ':' + (fractalMinutes < 10 ? '0' + fractalMinutes : fractalMinutes));

    fractalMinutes += 5;

    if (fractalMinutes >= 60) {
      fractalMinutes = 0;
      fractalHours++;
    }

    if (fractalHours === 24) {
      fractalHours = 5;
    }
  }

  if (window.isFractal) {
    updateFractalTime();
    window.setInterval(updateFractalTime, 30000);
  }

  function getNow() {
    return window.isFractal ? currentFractalTime : dayjs();
  }

  SWRNEU.Now = {
    getNow: getNow
  };
})(window.jQuery);
